module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_Emmanuel_Still.7098a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_Emmanuel_Still.jpg
// module id = pwl+
// module chunks = 0